import React from 'react';
import { dialogDirection } from '../../utils/updateDirection';

// In/Out for income, expense and other non-transfer rows, saved to
// transactions.direction (transfers use TransferPairFields). Starts from the
// row's sign and type; income must be In and expense Out.
export default function DirectionField({ transaction, type }) {
  if (type === 'transfer') return null;
  const start = dialogDirection(transaction, type); // refund defaults to In
  return (
    <div>
      <label className="block text-sm font-medium mb-1">Direction</label>
      <select key={`${transaction?.id || 'new'}-${type}`} name="direction" data-testid="direction" defaultValue={start} className="w-full border rounded px-3 py-2">
        <option value="">From type</option>
        <option value="in">In - money came into this account</option>
        <option value="out">Out - money left this account</option>
      </select>
      <p className="text-xs text-gray-600">{type === 'adjustment'
        ? 'Required for an adjustment: In raises this account\'s balance, Out lowers it.'
        : 'Income is always In and expense Out. Use Refund for other money in.'}</p>
    </div>
  );
}
